import * as yup from 'yup';
import { emailRegExp } from '../helpers/emailRegExp';

const phoneRegExp = /^\d{10,12}$/;

export const SignUpSchema = yup.object({
  firstName: yup
    .string()
    .min(2, 'First Name must contain at least 2 characters.')
    .max(16, 'First Name must contain at most 16 characters')
    .required('First Name is required'),
  lastName: yup
    .string()
    .min(2, 'Last Name must contain at least 2 characters.')
    .max(16, 'Last Name must contain at most 16 characters')
    .required('Last Name is required'),
  username: yup
    .string()
    .min(6, 'Username must contain at least 6 characters.')
    .max(30, 'Username must contain at most 30 characters')
    .required('Username is required'),
  jobTitle: yup
    .string()
    .min(2, 'Job Title must contain at least 2 characters.')
    .max(16, 'Job Title must contain at most 16 characters')
    .required('Job Title is required'),
  email: yup
    .string()
    .matches(emailRegExp, 'Invalid Email Address')
    .required('Email is required'),
  phoneNumber: yup
    .string()
    .matches(phoneRegExp, 'Invalid Phone Number')
    .required('Phone Number is required'),
  companyName: yup
    .string()
    .min(2, 'Company must contain at least 6 characters.')
    .max(100, 'Company must contain at most 100 characters')
    .required('Company Name is required'),
  country: yup.string().required('Country is required'),
  zipPostalCode: yup.string().required('Your zipcode is required'),
  password: yup
    .string()
    .min(6, 'Password must contain at least 6 characters.')
    .max(16, 'Password must contain at most 16 characters')
    .required('Password is required'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Confirmation password is required'),
  role: yup.string().oneOf(['reader', 'author', 'moderator']),
  acceptTerms: yup.boolean().required('You must accept the terms.'),
});
